import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { TranslationUtility } from '../../../utilities/TranslationUtility';
import { getPriceText } from '../../../utils/currencyFormatter';
import { PriceUtility } from '../../../utilities/PriceUtility';

const SummarySectionTitle = ({ section, includesPrices }) => {
    const { vat } = useSelector(state => state.configurator);
    return (
      <>
        <div className="summary-section-title-container">
          <div className="summary-section-title">{TranslationUtility.GetFormattedMessageForSectionName(section)}</div>
          {includesPrices ? (
            <div className="section-price">
              {getPriceText(PriceUtility.calculateSectionTotalPriceIncVat(section, vat), true)}
            </div>
        ) : null}
        </div>
        <div className="divider" />
      </>
);
};

SummarySectionTitle.propTypes = {
        section: PropTypes.shape({
            name: PropTypes.string,
        }).isRequired,
        includesPrices: PropTypes.bool.isRequired,
    };

        export default SummarySectionTitle;
